import React from 'react';

import { Text } from '~/domains/design-system/Text';

import type { ContestCardActionBanner } from './types';
import useStyles from './ContestCard.styles';

function ContestCardActionsBanner({ actionBanner }: { actionBanner: ContestCardActionBanner }) {
  const { classes } = useStyles({
    actionBannerColor: actionBanner?.color,
  });
  return (
      <Text tag="div" variant="body-small" className={classes.actionBanner}>
        {actionBanner.content}
      </Text>
  )
}

export default ContestCardActionsBanner
